import { render } from "./SpecificationPicker.vue?vue&type=template&id=7854a9cc"
import script from "./SpecificationPicker.vue?vue&type=script&lang=js"
export * from "./SpecificationPicker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__